import getAttachmentWellInitialValue from './getAttachmentWellInitialValue';
import ConversationAttachmentWellViewState from '../schema/ConversationAttachmentWellViewState';
import { ClientItemId } from 'owa-client-ids';

export default function getConversationAttachmentWellInitialValue(
    parentItemIdMap: { [index: string]: ClientItemId },
    itemReceivedTimeMap: { [index: string]: string }
): ConversationAttachmentWellViewState {
    const attachmentWell = getAttachmentWellInitialValue(
        true /*isReadOnly*/,
        false /*isInitialized*/,
        '' /*composeId is empty in read only mode*/
    );

    return {
        ...attachmentWell,
        parentItemIdMap: parentItemIdMap,
        itemReceivedTimeMap: itemReceivedTimeMap,
        isVisible: false,
        maxHeight: 0,
    };
}
